/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Done_KickerInputs */

const en_session_done_kicker = /** @type {(inputs: Session_Done_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook session · cooked`)
};

const de_session_done_kicker = /** @type {(inputs: Session_Done_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochsession · gekocht`)
};

/**
* | output |
* | --- |
* | "Cook session · cooked" |
*
* @param {Session_Done_KickerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_done_kicker = /** @type {((inputs?: Session_Done_KickerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Done_KickerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_done_kicker(inputs)
	return en_session_done_kicker(inputs)
});